angular.module("app").controller("LanguageController", [
    '$scope',
    'settingsService',
    '$translate',
    '$cookies',
    '$filter',
    function ($scope, settingsService, $translate, $cookies, $filter) {
        var translate = $filter("translate");
        var settings = settingsService.getSettings();
        $scope.languages = settings.languages;
        $scope.dropdownOptions = {
            enabled: false
        };
        $scope.currentLanguageName = $cookies.get("language") || settings.lang;
        $translate.use($scope.currentLanguageName || 'en');
        $scope.changeLanguage = function (langCode) {
            $cookies.put('language', langCode);
            $scope.currentLanguageName = langCode;
            $translate.use(langCode);
            $scope.dropdownOptions.enabled = false;
        }
    }
]);